import {
  type AllChatRoomItemType,
  type ChatRoom,
  type AllowedChatRoomItemType,
  ChatRoomItemType,
  type ChatRoomItem,
} from "@/Modules/Chat/Models/Domain/Chat";

import { hasValue, isObject } from "./Objects";

const isValidEvent = (event: unknown): event is AllowedChatRoomItemType => {
  return isObject(event) && event.type !== ChatRoomItemType.UNKNOWN && hasValue(event.createdAt);
};

const getLastEvent = (events: AllChatRoomItemType[]): AllChatRoomItemType | undefined =>
  events.findLast(isValidEvent);

export const sortChatRooms = (rooms: Record<string, ChatRoom>) => {
  return Object.values(rooms)
    .filter((val) => hasValue(val))
    .sort((a, b) => {
      let lastAEvent: AllChatRoomItemType | undefined = undefined;
      let lastBEvent: AllChatRoomItemType | undefined = undefined;

      if (a.events.length > 0) {
        lastAEvent = getLastEvent(a.events);
      } else if (isValidEvent(a.lastEvent)) {
        lastAEvent = a.lastEvent;
      }

      if (b.events.length > 0) {
        lastBEvent = getLastEvent(b.events);
      } else if (isValidEvent(b.lastEvent)) {
        lastBEvent = b.lastEvent;
      }

      if (lastAEvent === undefined && lastBEvent === undefined) return 0;

      if (!hasValue(lastAEvent) || !hasValue((lastAEvent as ChatRoomItem).createdAt)) return 1;
      if (!hasValue(lastBEvent) || !hasValue((lastBEvent as ChatRoomItem).createdAt)) return -1;

      if ((lastAEvent as ChatRoomItem).createdAt > (lastBEvent as ChatRoomItem).createdAt) return -1;
      if ((lastAEvent as ChatRoomItem).createdAt < (lastBEvent as ChatRoomItem).createdAt) return 1;
      if (
        (lastAEvent as ChatRoomItem).createdAt.getTime() === (lastBEvent as ChatRoomItem).createdAt.getTime()
      )
        return 0;

      return -1;
    });
};
